"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultRegistryUser = exports.onboardUser = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("regenerator-runtime/runtime.js");

var _storage = require("../../util/storage");

var _api = _interopRequireDefault(require("../../http/api"));

var _onboardEvents = require("../../tracking/onboard/onboardEvents");

var _onboardTrackingConstants = require("../../tracking/onboard/onboardTrackingConstants");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var onboardUser = function onboardUser(request) {
  var business_unit_feature = request.business_unit_feature,
      existing_account = request.existing_account,
      user = request.user;

  if (existing_account) {
    return _api.default.post('/web-api/v2/onboard/existing', request).then(function () {
      return (0, _helpers.performPostOnboardActions)({
        wasNewUser: false,
        business_unit_feature: business_unit_feature,
        business_unit_source: user === null || user === void 0 ? void 0 : user.business_unit_source
      });
    });
  }

  return _api.default.post('/web-api/v2/onboard/new', request).then(function () {
    return (0, _helpers.performPostOnboardActions)({
      wasNewUser: true,
      business_unit_feature: business_unit_feature,
      business_unit_source: user === null || user === void 0 ? void 0 : user.business_unit_source
    });
  });
};
/**
 * Creates a registry user with the defualt onboarding answers. This only works for existing users.
 */


exports.onboardUser = onboardUser;

var createDefaultRegistryUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(started_at) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _api.default.post('/web-registry-api/v1/onboard/submit/default', {
              started_at: started_at
            }).then(function (json) {
              (0, _onboardEvents.trackOnboardingCompleted)(_onboardTrackingConstants.BUSINESS_UNIT.WEDDING_REGISTRY, _onboardTrackingConstants.COMPONENT.REGISTRY, {
                isExistingUser: true
              });
              (0, _storage.setCookie)('checklistOnboard', true, 1);
              return json;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createDefaultRegistryUser(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.createDefaultRegistryUser = createDefaultRegistryUser;